import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL, LOCAL_TIMEZONE } from '../../Common/constant';

export const MY_SESSION_ACCESS = 'MY_SESSION_ACCESS';
export const FETCH_LIVE_SESSIONS = 'FETCH_LIVE_SESSIONS';
export const SINGLE_SESSION_DETAILS = 'SINGLE_SESSION_DETAILS';

export function fetchMyLiveSessions(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/mysessions`;
  var body = { appuserid: session.userid, eventid: session.eventid };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({ type: MY_SESSION_ACCESS, payload: response.resource });
        callback({ success: 1, data: response.resource });
      },
      error => {
        // callback({success: 0, message: error});
      }
    );
  };
}

export function clearMyLiveSessions() {
  return dispatch => {
    dispatch({ type: MY_SESSION_ACCESS, payload: [] });
  };
}

export function fetchLiveSessions(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/fetchsessions`;
  var body = {
    eventid: session.eventid,
    localtimezone: LOCAL_TIMEZONE
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response -> ', response);
        dispatch({ type: FETCH_LIVE_SESSIONS, payload: response.data });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function searchLiveSessions(session, search, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/serachsessions`;
  var body = {
    eventid: session.eventid,
    search: search,
    localtimezone: LOCAL_TIMEZONE
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response -> ', response);
        dispatch({ type: FETCH_LIVE_SESSIONS, payload: response.data });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function defaultSingleSessionDetails(data) {
  return dispatch => {
    dispatch({ type: SINGLE_SESSION_DETAILS, payload: data });
  };
}

export function fetchSingleSession(session, sessionid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessionid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session?related=speaker_by_sessionspeakers,speaker_by_speakerid,tickets_by_ticketid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: SINGLE_SESSION_DETAILS, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function applyCoupon(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/couponapply`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function makeStripePayment(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/buyproduct`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          dispatch(fetchMyLiveSessions(session));
          callback({ success: 1 });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function freeProductAccess(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/freeproductaccess`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          dispatch(fetchMyLiveSessions(session));
          callback({ success: 1 });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}
